import type { ReactNode } from 'react';

interface StatusPanelProps {
  title: string;
  children: ReactNode;
  action?: ReactNode;
  tone?: 'default' | 'error';
}

export function StatusPanel({ title, children, action, tone = 'default' }: StatusPanelProps) {
  return (
    <div
      className={`rounded-2xl border p-6 text-center shadow-card ${
        tone === 'error' ? 'border-rose-200 bg-rose-50' : 'border-indigo-100 bg-white/95'
      }`}
      role={tone === 'error' ? 'alert' : 'status'}
    >
      <h2 className={`text-xl font-black ${tone === 'error' ? 'text-rose-900' : 'text-aws-ink'}`}>
        {title}
      </h2>
      <div className={`mt-2 ${tone === 'error' ? 'text-rose-800' : 'text-aws-slate'}`}>{children}</div>
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function LoadingSkeleton({ label = 'Loading results' }: { label?: string }) {
  return (
    <div className="space-y-4" role="status" aria-label={label}>
      <span className="sr-only">{label}</span>
      <div className="h-28 animate-pulse rounded-2xl bg-indigo-100" />
      <div className="grid grid-cols-2 gap-3">
        {[0, 1, 2, 3, 4].map((item) => (
          <div key={item} className="h-20 animate-pulse rounded-xl bg-indigo-100" />
        ))}
      </div>
      <div className="h-56 animate-pulse rounded-2xl bg-indigo-100" />
    </div>
  );
}
